import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { IBLandingPageFilterKey } from 'api/ClientArea/LandingPageDto'
import { CompaniesFilter, CustomDateFilter } from 'components/Filter/common.filter'
import { SelectFilter } from 'components/Filter/SelectFilter'
import { YesNoFilter } from 'components/Filter/YesNoFilter'
import { useAppSelector } from 'store'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

const LanguageFilter = ({ filter, onFilterChange }: FilterProps) => {
  const languages = useAppSelector((state) => state.clients.language).filter(
    (x) => x.clientAreaVisible
  )
  const data = languages.map((url) => ({
    id: url.id.toString(),
    label: url.name,
    value: url.id.toString(),
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

const BaseURLFilter = ({ filter, onFilterChange }: FilterProps) => {
  const promoMaterialBaseUrls = useAppSelector(
    (state) => state.clientArea.promoMaterialsOptions.baseUrls
  )
  const data = promoMaterialBaseUrls.map((url) => ({
    id: url.id,
    label: url.name,
    value: url.id,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const getIBLandingPageFilterFields = (): FieldSettings[] => [
  {
    name: IBLandingPageFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.languageId,
    label: 'Language',
    filter: LanguageFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.promoMaterialBaseUrlId,
    label: 'Base URL',
    filter: BaseURLFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.tickmillCompanyId,
    label: 'Entity',
    filter: CompaniesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.enabled,
    label: 'Active',
    filter: YesNoFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.endDateTime,
    label: 'End Date',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: IBLandingPageFilterKey.dateUpdated,
    label: 'Last Updated',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
]
